import { LOCATION_CHANGE_HANDLE } from '../lib/redux-router';

import ActionTypes from '../constants/ActionTypes';
import ModalTypes from '../constants/ModalTypes';

const initialState = {
  isLogouting: false,
  currentModal: null,
  // FAMILY-EXT: матрица Эйзенхауэра — { cardId, options: [q1, q2] } | null
  pendingQuadrantPicker: null,
};

// eslint-disable-next-line default-param-last
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LOCATION_CHANGE_HANDLE:
    case ActionTypes.MODAL_CLOSE:
      return {
        ...state,
        currentModal: null,
        // FAMILY-EXT: матрица Эйзенхауэра — при навигации сбрасываем
        // незакрытый picker, чтобы он не "висел" на другой доске.
        pendingQuadrantPicker: null,
      };
    case ActionTypes.LOGOUT__ACCESS_TOKEN_INVALIDATE:
      return {
        ...state,
        isLogouting: true,
      };
    case ActionTypes.MODAL_OPEN:
      return {
        ...state,
        currentModal: payload.type,
      };
    // FAMILY-EXT: матрица Эйзенхауэра
    case ActionTypes.EISENHOWER_PICKER_SHOW:
      return {
        ...state,
        pendingQuadrantPicker: { cardId: payload.cardId, options: payload.options },
      };
    case ActionTypes.EISENHOWER_PICKER_HIDE:
      return {
        ...state,
        pendingQuadrantPicker: null,
      };
    case ActionTypes.USER_UPDATE_HANDLE:
      if (state.currentModal === ModalTypes.USERS && payload.isCurrent && !payload.user.isAdmin) {
        return {
          ...state,
          currentModal: null,
        };
      }

      return state;
    case ActionTypes.PROJECT_MANAGER_DELETE:
    case ActionTypes.PROJECT_MANAGER_DELETE_HANDLE:
      if (
        state.currentModal === ModalTypes.PROJECT_SETTINGS &&
        payload.isCurrentUser &&
        payload.isCurrentProject
      ) {
        return {
          ...state,
          currentModal: null,
        };
      }

      return state;
    default:
      return state;
  }
};
